import { mark } from 'src/sdk/tests/mark'

import 'src/styles/global/navbar.css'

import { RenderClient } from 'src/components/RenderClient'
import { useGlobalNavigation } from 'src/contexts/global-navigation-context'
import { MenuWrapper } from '../Menu/Common/MenuWrapper'
import { Header } from './Header/Header'
import { SubHeader } from './Subheader/SubHeader'
import { TopHeader } from './TopHeader/TopHeader'

function Navbar() {
  const { hasClickedOnPrivateArea } = useGlobalNavigation()

  return (
    <>
      <TopHeader />
      {/* DY Placement Placeholder  */}
      {/* <div
        id="HOME_PROMO_BANNER"
        className="bg-black px-6 py-1 lg:px-10 global-topheader"
      /> */}
      <Header />
      <SubHeader />

      <RenderClient>
        <MenuWrapper />
      </RenderClient>

      {hasClickedOnPrivateArea && (
        <div className="!bg-[rgba(0,0,0,0.30)] dropdown-subheader-overlay cloned"></div>
      )}
    </>
  )
}

Navbar.displayName = 'Navbar'

export default mark(Navbar)
